import './assets/styles/main.scss';
import '@amzn/event-engine-js-utils/esm/index.css';

import { loadPolyfills, Logger, LogLevel } from '@amzn/event-engine-js-utils';
import Providers from 'contexts';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App';
import reportWebVitals from './reportWebVitals';

const polyfillLogger = Logger.getLogger(
    'Polyfill',
    process.env.NODE_ENV === 'development' ? LogLevel.VERBOSE : LogLevel.ERROR
);

/**************************************************************
 * Amplify SDK Configuration with Auth
 *************************************************************/

const init = async () => {
    try {
        await loadPolyfills(polyfillLogger);
    } catch (e) {
        polyfillLogger.error('Unable to load polyfills', e);
    }

    ReactDOM.render(
        <React.StrictMode>
            <Providers>
                <App />
            </Providers>
        </React.StrictMode>,
        document.getElementById('root')
    );
};

init();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

export default init;
